import React from 'react';

import { Skeleton, Typography } from '@mui/material';

import { formatNumber } from '~/utils/numberFormatters';

import CompetitorOfferOpportunitiesTooltip from './CompetitorOfferOpportunitiesTooltip';
import { CompetitorOfferRow } from './utils';

interface Props {
  row: CompetitorOfferRow;
}

export default function CompetitorOfferGhaOpportunitiesCell({ row }: Props) {
  const { gha } = row;
  if (!row.lePropertyIds.length) {
    return null;
  }
  if (gha.status !== 'loaded') {
    return gha.status === 'loading' ? <Skeleton width={64} /> : <Typography color="text.secondary">—</Typography>;
  }
  if (!gha.opportunities) {
    return (
      <Typography variant="body2" color="text.secondary">
        No GHA data
      </Typography>
    );
  }

  return (
    <CompetitorOfferOpportunitiesTooltip
      hotelName={row.hotelName ?? row.externalPropertyId}
      opportunities={gha.opportunities}
    >
      <Typography variant="body2" fontWeight="medium" textAlign="right" width="100%">
        {formatNumber(gha.opportunities.opportunities)}
      </Typography>
    </CompetitorOfferOpportunitiesTooltip>
  );
}
